import PropTypes from 'prop-types';

import Badge from 'shopper/components/Badge';

import OFFER from 'constants/offer';

const BADGE_BY_VISIBILITY = {
  [OFFER.VISIBILITY_STATUS.LOGGED_ONLY]: OFFER.BADGES.EXCLUSIVE,
  [OFFER.VISIBILITY_STATUS.APP_ONLY]: OFFER.BADGES.APP_ONLY,
};

const OfferCardBadge = ({ className, offerUserVisibility }) => {
  const badge = BADGE_BY_VISIBILITY[offerUserVisibility];

  if (!badge) {
    return null;
  }

  return (
    <Badge className={className} type="secondary">
      {OFFER.BADGES.APP_ONLY}
    </Badge>
  );
};

OfferCardBadge.propTypes = {
  className: PropTypes.string,
  offerUserVisibility: PropTypes.string.isRequired,
};

export default OfferCardBadge;
